module.exports = __webpack_public_path__ + "static/img/sence-bg.796d0632.png";